import { isNumber } from '@/utils/is';

export const TFS_CHANNEL = 'bZ4X-MVP' as const;
export const TFS_PROCESS_STEP = {
	COLLECT_DEFAULTS: 'COLLECT_DEFAULTS',
	COLLECT_PRODUCTS: 'COLLECT_PRODUCTS',
	FULL_CALCULATION: 'FULL_CALCULATION'
} as const;
export type TFS_PROCESS_STEP = (typeof TFS_PROCESS_STEP)[keyof typeof TFS_PROCESS_STEP];

export const TFS_SCOPE = 'new_cars' as const;

export const CALC_FIELD_PART_SEPERATOR = '|' as const;
export const CASH_OPTION = 'CASH' as const;
export const DISCLAIMER = 'DISCLAIMER';
export const DISPLAY_TYPES_TO_FORMAT_AS_BOOLEANS = ['CHECKBOX'];
export const DISPLAY_TYPES_TO_FORMAT_AS_CURRENCIES = ['DISPLAY_CURRENCY', 'INPUT_CURRENCY', 'SLIDER_CURRENCY'];
export const DISPLAY_TYPES_TO_FORMAT_AS_NUMBERS = ['TOGGLE_INTEGER', 'SLIDER_INTEGER'];

export const EDIT_FINANCE_PARAM = 'EDIT_FINANCE';
export const FINANCE_CALCULATOR_INPUTS_PARAM = 'FCI';
export const FINANCE_CALCULATOR_INPUTS_VARIABLE = 'FINANCE_CALCULATOR_INPUTS';
export const FINANCE_OPTION = 'FINANCE_OPTION' as const;
export const FINANCE_PRODUCT_WITH_OPTIONS = 'FINANCE_PRODUCT_WITH_OPTIONS' as const;
export const FINANCIAL_PRODUCT = 'FINANCIAL_PRODUCT' as const;
export const FINANCIAL_PRODUCT_OPTION_DATA_TYPE = 'TEXT' as const;
export const INCLUDED_SERVICES = 'INCLUDED_SERVICES';
export const INSURANCE_SERVICE_CATEGORY = 'VEHICLE_INSURANCE';
export const OWNERSHIP = 'OWNERSHIP' as const;
export const OWNERSHIP_VALUE_MAPS_TO_RENTAL = 'CAPTIVE_COMPANY' as const;
export const SUMMARY_ORDER_FIELD = 'SUMMARY_FIELD' as const;

export const FINANCE_CALCULATOR_CASH_INPUT_VALUES = { field: FINANCIAL_PRODUCT, dataType: 'TEXT', value: CASH_OPTION } as const;

export const ADDITIONAL_BASKET_FINANCE_FIELDS = {
	APR: { basketKey: 'apr', typeCheck: isNumber },
	RESIDUAL_VALUE: { basketKey: 'gfv', typeCheck: isNumber },
	SUBSIDIES_AMOUNT: { basketKey: 'discount', typeCheck: isNumber }
} as const;

export const INPUT_BASKET_FINANCE_FIELDS = {
	TERM: { basketKey: 'term', typeCheck: isNumber, tfsType: 'INTEGER' },
	MILEAGE: { basketKey: 'mileage', typeCheck: isNumber, tfsType: 'INTEGER' },
	DEPOSIT: { basketKey: 'customerDeposit', typeCheck: isNumber, tfsType: 'INTEGER' }
} as const;

export const FINANCE_RETRY_ATTEMPTS = 3 as const;
export const SELECTED_FINANCE_PRICE_DATA_UNAVAILABLE = 'SELECTED_FINANCE_PRICE_DATA_UNAVAILABLE' as const;
